
<table mat-table [dataSource]="dataSource" >
    <ng-container *ngFor="let col of columns; let i = index;" matColumnDef="{{col.column}}">
        <th mat-header-cell *matHeaderCellDef> 
            <div *ngIf="col.isRightJustify===false">{{col.label}}</div>
            <div class="value-justify-right" *ngIf="col.isRightJustify===true">{{col.label}}</div>
        </th>
        <td mat-cell *matCellDef="let element" >
            <div *ngIf="col.isColour" [style.width.px]="col.minWidth">
                <mat-icon class="party-colour" [ngStyle]="{'color': element.colourCode}">
                    rectangle
                </mat-icon>
            </div>
            <div [style.min-width.px]="col.minWidth" class="value-justify-right"  *ngIf="col.isRightJustify&&col.isPercent===false">
                {{element[col.column]|number}}
            </div>
            <div [style.min-width.px]="col.minWidth" class="value-justify-right"  *ngIf="col.isPercent">
                <div *ngIf="col.isColourBar">
                    <svg style="width: 100px; margin-top: 10px; margin-left: 8px;" height="15">
                        <rect height="5" [style]="element[col.column]" />
                    </svg>
                </div>
                <div *ngIf="col.isColourBar===false">
                    {{(element[col.column]===null?'n/a':element[col.column])/100|percent :'1.1-1'}}
                </div>
            </div>
            <div [style.min-width.px]="col.minWidth" *ngIf="col.isRightJustify===false&&col.isColour===false">{{element[col.column]}}</div>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>
</table>
<div class="footnote">* indicates that the candidate was the existing member of parliament for this district.</div>